import { triggerDownloadRequest, getDownloadRequestStatus } from '../../services/manage'

const POLL_INTERVAL_MS = 2000
const TIMEOUT_MS = 60000

function extractRequestId(response) {
  return response?.data?.id ?? response?.data?.data?.id
}

function extractDownloadUrl(response) {
  return response?.data?.data?.downloadUrl ?? response?.data?.downloadUrl
}

async function pollForDownloadUrl(requestId) {
  const start = Date.now()
  while (Date.now() - start < TIMEOUT_MS) {
    try {
      const res = await getDownloadRequestStatus(requestId)
      const url = extractDownloadUrl(res)
      if (url) return url
    } catch (err) {
      if (err?.response?.status !== 404) throw err
    }
    await new Promise((r) => setTimeout(r, POLL_INTERVAL_MS))
  }
  return null
}

function triggerBrowserDownload(downloadUrl) {
  const link = document.createElement('a')
  link.href = downloadUrl
  link.setAttribute('download', '')
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export async function executeDownloadAll(site, { onError, onTimeout }) {
  const subdomain = site?.subdomain || site?.link
  if (!subdomain) return

  try {
    const createResponse = await triggerDownloadRequest({ subdomain })
    const requestId = extractRequestId(createResponse)
    if (!requestId) {
      onError('No request id returned')
      return
    }

    const downloadUrl = await pollForDownloadUrl(requestId)
    if (downloadUrl) {
      triggerBrowserDownload(downloadUrl)
    } else {
      onTimeout()
    }
  } catch (err) {
    const message =
      err?.response?.data?.message || err?.message || 'Unable to prepare zip. Please try again or contact support.'
    onError(message)
  }
}
